import React from 'react';
import { X, CheckCircle, AlertCircle, Info, AlertTriangle } from 'lucide-react';

export type ToastType = 'success' | 'error' | 'warning' | 'info';

export interface ToastProps {
    id: string;
    type: ToastType;
    title: string;
    message: string;
    onClose: (id: string) => void;
}

const toastConfig = {
    success: {
        icon: CheckCircle,
        bgColor: 'bg-green-500',
        borderColor: 'border-green-200',
        textColor: 'text-green-800',
        iconColor: 'text-green-600'
    },
    error: {
        icon: AlertCircle,
        bgColor: 'bg-red-500',
        borderColor: 'border-red-200',
        textColor: 'text-red-800',
        iconColor: 'text-red-600'
    },
    warning: {
        icon: AlertTriangle,
        bgColor: 'bg-orange-500',
        borderColor: 'border-orange-200',
        textColor: 'text-orange-800',
        iconColor: 'text-orange-600'
    },
    info: {
        icon: Info,
        bgColor: 'bg-blue-500',
        borderColor: 'border-blue-200',
        textColor: 'text-blue-800',
        iconColor: 'text-blue-600'
    }
};

export const Toast: React.FC<ToastProps> = ({ id, type, title, message, onClose }) => {
    const config = toastConfig[type];
    const Icon = config.icon;

    return (
        <div className={`flex items-start gap-3 p-4 bg-white dark:bg-gray-800 border-l-4 ${config.borderColor} rounded-lg shadow-lg max-w-sm w-full animate-in slide-in-from-right-full duration-300`}>
            <div className={`flex-shrink-0 w-8 h-8 rounded-full ${config.bgColor} flex items-center justify-center`}>
                <Icon className="w-5 h-5 text-white" />
            </div>
            <div className="flex-1 min-w-0">
                <h4 className={`text-sm font-semibold ${config.textColor} dark:text-gray-100`}>{title}</h4>
                <p className="text-sm text-gray-600 dark:text-gray-300 mt-1">{message}</p>
            </div>
            <button
                onClick={() => onClose(id)}
                className="flex-shrink-0 w-5 h-5 text-gray-400 dark:text-gray-500 hover:text-gray-600 dark:hover:text-gray-300 transition-colors"
            >
                <X className="w-4 h-4" />
            </button>
        </div>
    );
}; 